module.exports = __webpack_public_path__ + "static/media/size_9_off.e5455ac5.svg";